import React from 'react';
import NavBar from './NavBar.jsx';
import ReactDOM from 'react-dom';

import Ajax from './AJAX.jsx';
import InteractiveTable from './InteractiveTable.jsx';
import UpdateDataForm from './UpdateDataForm.jsx';
import {DropDownMultiSelector} from "./DropDownSelector.jsx";
import {UserListAddMultiple} from "./userListAddMultiple.jsx";
import {ConfirmModal} from "./ConfirmModal.jsx";
import * as tools from "./tools.jsx";
import {SelectBool} from "./genericElements.jsx";

class UsersList extends React.Component {
   constructor(props)
   {
      super(props);
      
      this.state = {
         data_roles:[],
         data_users:[],
         data_contexts:[]
      }

      var clickedUser = function(user)
      {
         console.log('clicked context name: ' + user.name);
      }.bind(this);

      this.userClickMap = 
      {
         name:clickedUser,
         user_id:clickedUser
      }

      this.extraBtns = [
         {
            name:"edit",
            click: this.clickedEdit.bind(this)
         },
         {
            name:"delete",
            click: this.clickedDelete.bind(this)
         }
      ]
   }


   clickedAddNew()
   {
      const newUserData = {
         name:"",
         password:"",
         email: "",
         role: 1,
         contexts:[],
         active: 1
      }

      this.showUserData(newUserData, false);
   }

   clickedAddMultiple()
   {
      const self = this;

      const modalProps = {
         user:this.props.user,
         appCallbacks:this.props.appCallbacks,
         onDoneAdding:()=>{self.refreshData();},
      }
      self.props.appCallbacks.pushModal({modalClass:UserListAddMultiple, modalProps:modalProps});
   }

   clickedEdit(user)
   {
      this.showUserData(user, true);
   }

   clickedDelete(user)
   {
      const self = this;

      const onConfirmDelete = ()=>
      {
         const onServerDelete = (response) => {
            if(response.success)
            {
               self.refreshData();
            }
            else
            {
               self.props.appCallbacks.showResponseErr(response, "Failed deleting user");
            }
         }
         self.props.appCallbacks.performAjaxRequest('users/' + user.user_id, "DELETE", null, onServerDelete, false);
      }
      const onCancelDelete = ()=>{};

      const modalProps = {
         heading: "Confirm Delete",
         msg:"Delete user: " + user.name + " ?",
         onConfirm:onConfirmDelete,
         popModal: this.props.appCallbacks.popModal,
      }
      this.props.appCallbacks.pushModal({modalClass:ConfirmModal, modalProps:modalProps});
   }

   showUserData(user, userExists)
   {
      const self = this;

      var onSaveCallback = function(newUserData)
      {
         if(newUserData)
         {
            var onUserUploaded = function(responseObj)
            {
               if(responseObj.success){
                  self.props.appCallbacks.popModal();
                  self.refreshData();
               }
               else
               {
                  self.props.appCallbacks.showResponseErr(responseObj, "Add / Edit User");
               }
            } 
            if(userExists)
               self.props.appCallbacks.performAjaxRequest('users/' + newUserData.user_id, "PUT", newUserData, onUserUploaded, false);
            else
               self.props.appCallbacks.performAjaxRequest('users', "POST", newUserData, onUserUploaded, false);
               
         }
         else
         {
            self.props.appCallbacks.popModal();
         }
      }

      const drawFunctions =
      {
         role:DropDownMultiSelector,
         contexts:DropDownMultiSelector,
         user_id:tools.FreezeElement,
         active:SelectBool,
      }

      const roleObjects = self.state.data_roles.filter((r)=>{return r.role_id<=this.props.user.role_id}).map((r)=>{return {id:r.role_id, name:r.role_name}});

      const contextObjects = self.state.data_contexts.map((c)=>{return{id:c.context_id,name:c.name}});

      const modalProps = {
         saveCallback:onSaveCallback,
         heading: userExists ? "Edit User" : 'Add new User',
         data:user,
         drawFuncs:drawFunctions,
         drawFuncObjects:{contexts:{objects:contextObjects}, role:{objects:roleObjects, selectSingle:true}},
      }

      self.props.appCallbacks.pushModal({modalClass:UpdateDataForm, modalProps:modalProps});

   }
   

   refreshData()
   {
      
      this.props.appCallbacks.performAjaxRequest("contexts", "GET", null,
         tools.getSetBaseDataFunc(this, "data_contexts").bind(this));

      this.props.appCallbacks.performAjaxRequest("users", "GET", null,
         tools.getSetBaseDataFunc(this, "data_users").bind(this));

      this.props.appCallbacks.performAjaxRequest("roles", "GET", null,
         tools.getSetBaseDataFunc(this, "data_roles").bind(this));
   }

   componentDidMount()
   {
      this.refreshData();
      
   }

   getInterpreter()
   {
      const getContexts = (ids)=> ids.map((id)=>{return this.state.data_contexts.find((con)=>{return con.context_id == id;})});
      //const getContextNames = (ids)=>{getContexts(ids).map((con)=>{return con ? con.name : "Non-existent";})}
      const getRole = (id)=> this.state.data_roles.find((r)=>{return r.role_id == id;});
      //const getRoleName = (id) => {const role = getRole(id); return role ? role.name : "Non-existent";}
      return (
      {
         contexts: (ids)=>{return getContexts(ids).map((con)=>{ return con ? con.name : "Non-existent";})},
         role: (id) => {const role = getRole(id); return role ? role.role_name : "Non-existent";}
      });
   }


   render() {
      var tableStyle1 = {
         background: '#DDDDDD',
         padding: 5 
      }
      
      var tableStyle2 = Object.assign({},tableStyle1);

      tableStyle2.background = '#F0F0F0';

      const restrictions = this.props.pageData.restrictions;
      const filter = (user) =>
      {
         if(restrictions.hasOwnProperty("context_id"))
         {
            if(user.contexts.includes(restrictions["context_id"]))
            {
               return true;
            }
         }
         return false;
      }

      const filteredUsers = restrictions ? 
      this.state.data_users.filter(filter) :
      this.state.data_users;

      return (
         <div>
            <h1> Users </h1>
             <button onClick={this.clickedAddNew.bind(this)}>Add User</button>
            <button onClick={this.clickedAddMultiple.bind(this)}>Add Multiple Users</button>
            <InteractiveTable extraBtns={this.extraBtns} rowObjects={filteredUsers} clickMap={this.userClickMap} interpreter={this.getInterpreter()} hideColumns={["active"]}/>

         </div>
      );
   }
}

export default UsersList ;


// WEBPACK FOOTER //
// ./js/userList.jsx